import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  Button,
  FormHelperText,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { kmMessages } from "src/constant/Messages";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Skeleton from "@material-ui/lab/Skeleton";
import { fillMissingTags } from "src/utils/utils";

const nameMaxLength = 300;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}${nameMaxLength}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const Form = ({
  onSubmit,
  sidesRepresented,
  institution,
  editMode,                                    
  areDictsLoaded,       
  ...rest
}) => {
  const classes = useStyles();
  const [defaultSideRepresented, setDefaultSideRepresented] = useState(null);
  const [defaultSideRepresentedName, setDefaultSideRepresentedName] = useState("");

  const { handleSubmit, setValue, control, errors } = useForm();

  useEffect(() => {

    if (editMode) {
      if (institution && institution.name && institution.sideRepresented){
        setValue("name", institution.name);
  
        setValue("sideRepresented", institution.sideRepresented);
        setDefaultSideRepresented(institution.sideRepresented);
        setDefaultSideRepresentedName(institution.sideRepresented.name);
      }
    }
    return () => {};
  }, [institution, areDictsLoaded, sidesRepresented]);

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, []);

  return (
    <Card className={clsx(classes.root)} {...rest}>
        <Box component="main">
          <Grid container className={classes.root}>
            <Grid item xs={12} elevation={2}>
              {areDictsLoaded ? (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <FormControl
                    fullWidth
                    className={classes.formcontrol}
                    variant="outlined"
                  >
                    <Controller
                      as={
                        <TextField
                          autoFocus
                          error={errors.name ? true : false}
                          id="name"
                          name="name"
                          label="Nazwa"
                          placeholder="Nazwa"
                          multiline
                          helperText={
                            errors.name &&
                            (formValidation[errors.name.type] || "")
                          }
                        />
                      }
                      name="name"
                      defaultValue=""
                      control={control}
                      rules={{ required: true, maxLength: nameMaxLength }}
                    />
                  </FormControl>
                  {sidesRepresented && sidesRepresented.length > 0 ? (
                   
                    <Controller
                      render={({ onChange, ...props }) => (
                        <Autocomplete
                          id="side-repr"
                          options={sidesRepresented}
                          getOptionLabel={(option) => option.name}
                          getOptionSelected={(option, value) => value && option.id === value.id}
                          value={props.value}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={errors.sideRepresented ? true : false}
                              label="Reprezentowana strona"
                              placeholder="Reprezentowana strona"
                              onChange={(e, data) => onChange(data)}
                             
                              helperText={
                                errors.sideRepresented &&
                                (formValidation[errors.sideRepresented.type] ||
                                  "")
                              }
                            />
                          )}
                          onChange={(e, data) => onChange(data)}
                        />
                      )}
                      onChange={([, data]) => data}
                      name="sideRepresented"
                      control={control}
                      rules={{ required: true }}
                      defaultValue={defaultSideRepresented}
                    />
                  ) : (
                    <Skeleton />
                  )}
                  <Box className={classes.paddingtop}>
                    <Button
                      color="primary"
                      className={classes.button}
                      component={RouterLink}
                      to="/administracja/slowniki/1"
                    >
                      Anuluj
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.button}
                      endIcon={<SaveIcon />}
                      type="submit"
                    >
                      Zapisz
                    </Button>
                  </Box>
                </form>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Box>
    </Card>
  );
};

export default Form;
